






import { Component, Vue } from "vue-property-decorator";
import StatisticsContainer from "@/components/stats/StatisticsContainer.vue";

@Component({
    components: {
        StatisticsContainer,
    },
})
export default class Statistics extends Vue {} 
